import * as React from 'react';

// @ts-expect-error - imported from .js/.jsx file
import {VirtualMeetingIcon} from 'shells/icon/svg/virtual-meeting-icon';
import {Body} from 'shells/typography/body';

import type {PotentialActivityEntityFragment as Participant} from 'nutshell-graphql-types';

import styles from './activity-row.module.css';

type Props = {
    participants: Participant[];
    name: string;
    hasExternalMeeting: boolean;
};

export function ActivityRowTopSection(props: Props) {
    if (props.participants.length === 0) {
        return null;
    }

    const mainParticipant = props.participants[0];
    const otherParticipants = props.participants.slice(1);

    const displayParticipants = otherParticipants.map((p, index) =>
        index === otherParticipants.length - 1 ? p.name : `${p.name}, `
    );

    return (
        <div className='flex gap-8 full-width'>
            <div className={styles['top-row-section-left']}>
                <div className='flex align-center justify-start full-width gap-4'>
                    <Body isBold={true} size='normal' truncate={{type: 'inline'}}>
                        {props.name}
                    </Body>
                    {props.hasExternalMeeting && (
                        <VirtualMeetingIcon size={14} alignCenter={true} />
                    )}
                </div>
            </div>
            <div className={styles['top-row-section-right']}>
                <span className={styles['host-name']}>
                    <Body isBold={true} size='small' truncate={{type: 'inline'}}>
                        {/* @ts-expect-error */}
                        {mainParticipant.name}
                    </Body>
                </span>
                <Body color='light' size='small' truncate={{type: 'inline'}}>
                    {displayParticipants}
                </Body>
            </div>
        </div>
    );
}
